/* ========================================================================== *\
    Imports
/* ========================================================================== */
import { isElement } from 'lodash';

import { subscribe } from '../2-utilities/event';
import { queryAncestor } from '../2-utilities/dom';

import {
    MARKER_SELECTED,
    MARKER_DESELECTED,
    ROW_CLICKED,
    SIDEBAR_OPENED,
    FILTER_OPENED,
    SEARCH_OPENED,
    SEARCH_ENTERED,
    YEAR_CHANGED,
} from '../3-data/consts/eventNames';

/* ========================================================================== *\
    Constants
/* ========================================================================== */
const moduleName = 'detail-popup-dialog',
    baseSelector = `.js-${moduleName}`,
    jsClassName = `js-${moduleName}`,
    jsClassNames = {
        base: jsClassName,
        container: `${jsClassName}-container`,
        content: `${jsClassName}-content`,
    },
    selectors = {
        base: baseSelector,
        container: `.${jsClassNames.container}`,
        content: `.${jsClassNames.content}`,
    };

/* ========================================================================== *\
    Functionality
/* ========================================================================== */

function showPopupAferSearch({ detail }) {
    const { marker } = detail;

    if (!marker) {
        return;
    }

    const html = marker.querySelector('.js-detail-popup').innerHTML;

    showDetailPopup({ detail: html });
}

function showPopupAferList({ detail }) {
    const { index } = detail,
        elements = document.querySelectorAll('.js-marker'),
        element = elements[index];

    if (!element) {
        return;
    }

    const html = element.querySelector('.js-detail-popup').innerHTML;

    showDetailPopup({ detail: html });
}

function showDetailPopup(event) {
    const container = document.querySelector(selectors.container);
    container.classList.remove('--hide');
    const content = document.querySelector(selectors.content);
    content.innerHTML = event.detail;
}

function hideDetailPopup() {
    const container = document.querySelector(selectors.container);
    container.classList.add('--hide');
    const content = document.querySelector(selectors.content);
    content.innerHTML = "";
    window.map.setCenter({ lat: 52.084166, lng: 5.5124522 });
}

function binding() {
    document.body.addEventListener('click', (e) => {
        const container = document.querySelector(selectors.container);

        if (container.classList.contains('--hide')) {
            return;
        }

        if (!queryAncestor(e.target, baseSelector) && !queryAncestor(e.target, '.js-marker') && !queryAncestor(e.target, '.c-list__row')) {
            hideDetailPopup();
        }
    });

    subscribe(MARKER_SELECTED, showDetailPopup);
    subscribe(MARKER_DESELECTED, hideDetailPopup);
    subscribe(ROW_CLICKED, showPopupAferList);
    subscribe(SEARCH_ENTERED, showPopupAferSearch);
    subscribe(SIDEBAR_OPENED, hideDetailPopup);
    subscribe(FILTER_OPENED, hideDetailPopup);
    subscribe(SEARCH_OPENED, hideDetailPopup);
    subscribe(YEAR_CHANGED, hideDetailPopup);
}

function init(baseElement = document.querySelector(selectors.base)) {
    if (!isElement(baseElement)) {
        return false;
    }

    binding(baseElement);
}

init();